export default __webpack_public_path__ + "static/media/2.d878f729.png";